import { create } from 'zustand';

/** Controllers shown as raw text instead of the Animator editor (per path). */
export const useControllerTextMode = create<{ paths: ReadonlySet<string> }>(() => ({ paths: new Set() }));

/** Shows `path` in the visual Animator editor (false) or as text (true) when the Code tab displays it. */
export function setControllerTextMode(path: string, text: boolean): void {
  const current = useControllerTextMode.getState().paths;
  if (current.has(path) === text) return;
  const paths = new Set(current);
  if (text) paths.add(path);
  else paths.delete(path);
  useControllerTextMode.setState({ paths });
}
